export default __webpack_public_path__ + "static/media/bg_06.66df8ecf.png";